import { render, staticRenderFns } from "./AppSelect.vue?vue&type=template&id=04b8689d&"
import script from "./AppSelect.vue?vue&type=script&lang=js&"
export * from "./AppSelect.vue?vue&type=script&lang=js&"
import style0 from "./AppSelect.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports